<template>
  <div>
    <h4>汇总</h4>
    <el-table :data="statistics">
      <el-table-column prop="user_count" label="累计购买人数"/>
      <el-table-column prop="order_count" label="累计订单"/>
      <el-table-column prop="total_price" label="累计交易金额"/>
      <el-table-column prop="total_reward_amount" label="累计分佣"/>
    </el-table>
    <h4>明细</h4>
    <el-table :data="dataList">
      <el-table-column prop="date" label="日期"/>
      <el-table-column prop="user_count" label="购买人数"/>
      <el-table-column prop="order_count" label="订单数"/>
      <el-table-column prop="visit_count" label="访问PV"/>
      <el-table-column prop="distinct_visit_count" label="访问UV"/>
      <el-table-column prop="total_price" label="交易金额"/>
      <el-table-column prop="total_reward_amount" label="分佣金额"/>
      <el-table-column prop="id" label="操作">
        <template slot-scope="scope">
          <el-button size="small" @click="handleClickItem(scope.row)"
          >每日详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pager api="channel_statistics_list" model="shop" :params="getRequestParams" @data-changed="onDataChanged"/>
  </div>
</template>
<script>
  import Pager from "../ui/Pager"
  import request from "../../api/request";
  import money from '../../util/money'

  export default {
    name: 'ShopChannelStatistics',
    components: {Pager},
    data() {
      return {
        statistics: [],
        dataList: []
      }
    },
    computed: {
      getRequestParams() {
        return {
          channel: parseInt(this.$route.params['channel'])
        }
      }
    },
    created() {
      this.loadData()
    },
    methods: {
      onDataChanged(data) {
        this.dataList = data
        this.dataList.map(item => {
          item.total_price = money.toYuanWithUnitAndPoint(item.total_price)
          item.total_reward_amount = money.toYuanWithUnitAndPoint(item.total_reward_amount)
        })
      },
      loadData() {
        request.shop.post('/channel_statistics_sum_get', {channel: parseInt(this.$route.params['channel'])})
          .then(r => {
            this.statistics.push(r.data)
            this.statistics.map(item => {
              item.total_price = money.toYuanWithUnitAndPoint(item.total_price)
              item.total_reward_amount = money.toYuanWithUnitAndPoint(item.total_reward_amount)
            })
          })
          .catch(() => {
          })
      },
      handleClickItem(row) {
        this.$router.push({
          path: '/shop/ShopOrder',
          name: "订单",
          params: {
            channel: this.$route.params['channel'],
            date: row.date
          }
        });
      },
      handleMoneyToYuan(amount) {
        return  money.toYuanWithUnitAndPoint(amount)
      }
    },
  }
</script>
